import React from "react";

const SidebarSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse h-full">
      {/* Skeleton for Folder List */}
      {Array.from({ length: 3 }).map((_, folderIndex) => (
        <div key={folderIndex+1} className="mb-1">
          {/* Skeleton Folder Header */}
          <div className="flex justify-between items-center w-full p-2 rounded-lg">
            <div className="flex items-center w-full">
              <div className="h-4 w-4 bg-[#3741514f] dark:bg-[#4b55634d] rounded-full mr-3"></div>
              <div className="h-4 w-32 bg-[#3741514f] dark:bg-[#4b55634d] rounded"></div>
            </div>
            <div className="h-4 w-4 bg-[#3741514f] dark:bg-[#4b55634d] rounded"></div>
          </div>

          {/* Skeleton Folder Content */}
          <ul className="ml-6 mt-2 space-y-1">
            {Array.from({ length: 2 }).map((_, chatIndex) => (
              <li key={chatIndex+1}>
                <div className="flex justify-between items-center p-2 rounded-lg bg-gray-200 dark:bg-[#3741514f]">
                  <div className="h-4 w-40 bg-[#4a5b771c] dark:bg-[#4b55634d] rounded"></div>
                  <div className="h-4 w-4 bg-[#4a5b771c] dark:bg-[#4b55634d] rounded"></div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default SidebarSkeleton;
